import { InvoiceDetails, TenantOptionsDetails } from "features/types";

import dayjs from "dayjs";
import { svgURL } from "utils/fileUtils";
import { formatCurrency } from "utils/appUtils";

export default (
  invoice: InvoiceDetails,
  tenantConfig: TenantOptionsDetails,
  entityName: string
) => {
  const tenantLogo = svgURL(entityName, false);

  const generateInvoiceDetailsHtml = () => {
    return invoice.items
      .map(
        (item) => `
            <div class="flex justify-between no-wrap mb-2">
                <div>${item.description}</div>
                <div class="text-weight-bold">
                    ${formatCurrency(item.amount)}
                </div>
            </div>
            <div class="mb-2 border-bottom">
                <div>Paid at: ${dayjs(item.paidAt)
                  .tz(tenantConfig.timezone || "")
                  .format("MMM DD, YYYY hh:mm:ss A")}</div>
                <div>
                   Payment method: Card ending in ${item.billingLast4}
                </div>
                <div>
                    Transaction #: 
                    ${item.ledgerTransactionId} - 
                    ${item.ledgerItemId}
                </div>
            </div>
        `
      )
      .join("");
  };
  const generateContact = () => {
    const supportEmail = tenantConfig.supportEmail;
    const supportPhone = tenantConfig.supportPhone;
    return `<div>
                <div>
                    If you have any questions, contact us
                    at ${supportEmail ? supportEmail : ""}
                    ${supportEmail && supportPhone ? "or call us at" : ""}
                    ${supportPhone ? supportPhone : ""}
                </div>
            </div>`;
  };
  return `
    <html>
        <head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">
            <style>
                body {
                    max-width:500px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    font-size: 1rem;
                    padding: 12px;
                    font-family: 'Roboto', sans-serif;
                }
                .flex {
                    display: flex;
                }
                .justify-between {
                    justify-content: space-between;
                }
                .no-wrap {
                    flex-wrap: no-wrap;
                }
                .mt-2 {
                    margin-top: 12px;
                }
                .mt-5 {
                    margin-top: 30px;
                }
                .column {
                    flex-direction: column;
                }
                .mr-2 {
                    margin-right: 12px;
                }
                .mb-1 {
                    margin-bottom: 6px;
                }
                .mb-2 {
                    margin-bottom: 12px;
                }
                .text-weight-bold {
                    font-weight: 700;
                }
                .border-bottom {
                    padding-bottom: 6px;
                    border-bottom: 1px solid #cccccc;
                }
                .title {
                    font-size: 1.5rem;
                }
                .text-center {
                    text-align:center;
                }
                .text-right {
                    text-align:right;
                }
                .text-green {
                    color: rgb(22, 163, 74);
                }
            </style>
        </head>
        <body>
            <div class="mt-2"><img src="https://branding.fanrally.com/logos/fanrally_logo_master.png" width="200px"/></div>

            <div class="mt-5">
                <div class="text-weight-bold">Summary</div>

                ${generateInvoiceDetailsHtml()}

                <div>
                    <div class="text-weight-bold flex justify-between no-wrap mb-2">
                        <div>Payment Details</div>
                    </div>
                    <div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Subtotal</div>
                            <div class="text-weight-bold">
                                ${formatCurrency(invoice.amount)}
                            </div>
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Fees</div>
                            <div class="text-weight-bold">
                                ${formatCurrency(invoice.fees)}
                            </div>
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Taxes</div>
                            <div class="text-weight-bold">
                                ${formatCurrency(invoice.taxes)}
                            </div>
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Credits</div>
                            <div class="text-weight-bold text-green">
                                ${formatCurrency(invoice.credits)}
                            </div>
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Refund</div>
                            <div class="text-weight-bold text-green">
                                ${formatCurrency(
                                  Math.abs(Number(invoice.refunds))
                                )}
                            </div>
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Total</div>
                            <div class="text-weight-bold">
                                ${formatCurrency(invoice.charges)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-2">
                ${generateContact()}
            </div>

            <div class="mt-5 text-center">
                <img src="${tenantLogo}" height="375px" style="opacity: 0.2;width:100%"/>
            </div>
        </body>
    </html>
    `;
};
